export default "__VITE_ASSET__BAs9rrNb__"